import { TrlAnalysisSummaryDto } from '@@types/api.types';
import { ConfidenceScore } from '@components/shared/confidence-score.component';
import { FC } from 'react';

type TrlAnalysisSuggestionContentProps = {
  summary: TrlAnalysisSummaryDto;
};

export const TrlAnalysisSuggestionContent: FC<TrlAnalysisSuggestionContentProps> = (props) => {
  const { summary } = props;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <ConfidenceScore
          design="box"
          score={summary.confidence}
          size="small"
        />
        <div className="flex flex-col leading-tight">
          <span className="text-sm font-medium text-gray-800">TRL Analysis</span>
          <span className="text-xs text-gray-500">Confidence Score</span>
        </div>
      </div>
      <p className="whitespace-pre-wrap text-sm leading-relaxed text-gray-700">{summary.scoreAnalysis}</p>
    </div>
  );
};
